<template>
    <div id="shequCourse">
        <div class="content relative sec mt20">
            <div class="tab-head myflex-v">
                <div class="tab-item tabTitle myflex-v">
                    <img src="@/assets/img/icon1.png" class="title-icon-img" /><span>网上社区艺术教育大讲堂</span>
                </div>
                <div class="sec-right-up myflex-v marginauto-l">
                    <div class="look-more" @click="lookMore">查看更多<i class="el-icon-arrow-right"></i></div>
                </div>
            </div>
    
            <div class="course-box mt15" v-loading="loading">
                <!-- 课程列表 -->
                <el-row :gutter="15" class="courseListBox" v-if="courseList.length>0">
                    <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-for="(item3,index3) in courseList" :key="index3" >
                        <CourseListItem 
                            :courseid="item3.courseId"
                            :studioid="item3.studioId"
                            :cover="item3.courseCover" 
                            :name="item3.courseName" 
                            :label="item3.courseLabelNames" 
                            :majorname="item3.majorName" 
                            :teacher="item3.ownerName" 
                            :type="item3.courseType"
                        />
                    </el-col>
                </el-row>
                <div v-else class="nodata pad15">暂无数据~</div>
            </div>
                   
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .course-box{padding:0 15px;min-height:100px;}
</style>

<script>
import CourseListItem from '@/components/CourseListItem.vue';
export default {
    name: "shequCourse",
    components: {
        CourseListItem,
    },
    data(){
        return {
            activeName: 'first',
            courseList:[
                // {
                //     studioId: 1,
                //     courseId: 2048,
                //     courseCover: 'studio/C7A35620-A702-4058-A3C1-110F6FC482E2.png',
                //     courseName: '中国合唱协会网络合唱学院示范课系列之应用和声基础1',
                //     courseType: 1,
                //     courseLableNames: '标签1,标签2',
                //     majorName: '合唱',
                //     ownerName: '黄老师'
                // },
            ],
            loading: true,
        }
    },
    methods: {
        lookMore: function(){
            art.openShequCourse();
        },

        getList(){
            this.$api.web.communityCourseSelectTop10Courses({topType:'month',pageNum:1,pageSize:8}).then(res=>{
                var d = res.body.communityCourses;
                if( d && d.length>0 ){
                    this.courseList = d.slice(0,8);
                }
                this.loading = false;
            }).catch(res=>{
                this.loading = false;
            })
        },
    },
    created(){
       
    },
    mounted(){
        setTimeout(() => {
           this.getList(); 
        }, 1000);
    },
}
</script>